import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import './LegalPage.css';

const PrivacyPage = () => {
  return (
    <div className="legal-page">
      <Seo
        title="Datenschutz | Sportphysiotherapie Oliver Bauer"
        description="Datenschutzhinweise der Sportphysiotherapie Oliver Bauer für Hornstein, Leobersdorf, Wiener Neustadt und Umgebung."
        canonical="/datenschutz"
      />
      <Navigation activeSection="" simple />
      <main className="legal-wrapper">
        <section className="legal-content">
          <h1 className="heading-2">Datenschutz</h1>
          <p className="body-large section-subtitle">
            Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO
          </p>

          <div className="legal-block">
            <p className="legal-label">1. Verantwortlicher</p>
            <address>
              Oliver Bauer, BSc., Master in Exercise and Sports Physiotherapy<br />
              Alte Bandfabrik 1, 7053 Hornstein<br />
              Telefon: <a href="tel:+436641510494">0664 1510494</a><br />
              E-Mail: <a href="mailto:office@physiotherapie-oliverbauer.com">office@physiotherapie-oliverbauer.com</a>
            </address>
          </div>

          <div className="legal-block">
            <p className="legal-label">2. Verarbeitung personenbezogener Daten</p>
            <p>
              Beim Besuch dieser Website werden grundsätzlich keine personenbezogenen Daten gespeichert,
              sofern dies nicht für die technische Bereitstellung notwendig ist. Eine Verarbeitung erfolgt
              nur im Rahmen des angebotenen Kontaktformulars.
            </p>

            <p>Verarbeitete Daten über das Kontaktformular:</p>
            <ul>
              <li>Name</li>
              <li>Telefonnummer</li>
              <li>E-Mail-Adresse</li>
              <li>Anliegen / Nachricht</li>
              <li>Bevorzugte Termine (optional)</li>
              <li>IP-Adresse (automatisch durch den Hostinganbieter erfasst)</li>
            </ul>

            <p>
              Das Kontaktformular wird über <strong>Netlify Forms</strong> bereitgestellt. Die eingegebenen
              Daten werden kurzfristig auf den Servern von Netlify gespeichert und anschließend automatisiert
              per E-Mail an den Verantwortlichen weitergeleitet. Eine dauerhafte Speicherung auf Netlify erfolgt nicht.
            </p>
          </div>

          <div className="legal-block">
            <p className="legal-label">3. Zweck der Verarbeitung</p>
            <ul>
              <li>Beantwortung Ihrer Anfrage</li>
              <li>Terminvereinbarung</li>
              <li>Kontaktaufnahme</li>
            </ul>
            <p>Es werden keine darüber hinausgehenden Zwecke verfolgt.</p>
          </div>

          <div className="legal-block">
            <p className="legal-label">4. Rechtsgrundlagen</p>
            <ul>
              <li>Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen, Terminvereinbarung)</li>
              <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an effizienter Kommunikation und Schutz der Website)</li>
            </ul>
          </div>

          <div className="legal-block">
            <p className="legal-label">5. Empfänger und Auftragsverarbeiter</p>
            <p>Zur Bereitstellung dieser Website, des Kontaktformulars und des E-Mail-Versands werden externe Dienstleister eingesetzt.</p>
            <div className="legal-subsection">
              <h4>5.1 Hosting – Frontend (Netlify)</h4>
              <p>
                Netlify, Inc., 2325 3rd Street, Suite 296, San Francisco, CA 94107, USA. Netlify verarbeitet technische
                Daten (z. B. IP-Adresse, Browserdaten, Logfiles) zur Auslieferung der Website. Es kann zu einer
                Übermittlung personenbezogener Daten in die USA kommen.
              </p>
            </div>
            <div className="legal-subsection">
              <h4>5.2 Formularverarbeitung (Netlify Forms)</h4>
              <p>
                Für die Verarbeitung von Formularanfragen verwenden wir <strong>Netlify Forms</strong>,
                einen Dienst der Netlify Inc., 2325 3rd Street, Suite 296, San Francisco, CA 94107, USA.
                Die vom Nutzer eingegebenen Daten werden über die Server von Netlify verarbeitet und uns
                anschließend per E-Mail zugestellt.
              </p>
              <p>
                Netlify agiert dabei als Auftragsverarbeiter gemäß Art. 28 DSGVO. Die Verarbeitung erfolgt
                auf Basis der <em>Standardvertragsklauseln (SCC)</em>, die ein angemessenes Schutzniveau
                gewährleisten.
              </p>
            </div>
            <div className="legal-subsection">
              <h4>5.5 Auftragsverarbeitung (DPA / AVV)</h4>
              <p>
                Mit Netlify besteht ein Vertrag zur Auftragsverarbeitung gemäß Art. 28 DSGVO.
                Die Datenübermittlung in die USA erfolgt auf Basis der EU-Standardvertragsklauseln (SCC).
                Netlify stellt diese sowohl für kostenlose als auch für kostenpflichtige Tarife zur Verfügung.
              </p>
            </div>
          </div>

          <div className="legal-block">
            <p className="legal-label">6. Speicherdauer</p>
            <p>
              Die über das Kontaktformular übermittelten Daten werden nach Weiterleitung per E-Mail
              auf den Servern von Netlify automatisch nach kurzer Zeit gelöscht. Bei uns (Oliver Bauer) werden die
              empfangenen E-Mails entsprechend der gesetzlichen Aufbewahrungsfristen gespeichert
              oder auf Anfrage gelöscht.
            </p>
          </div>

          <div className="legal-block">
            <p className="legal-label">7. Server-Logfiles</p>
            <p>
              Netlify erfasst automatisch IP-Adresse, Datum/Uhrzeit, Browsertyp, Betriebssystem,
              Referrer-URL und Zugriffsstatus. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (Sicherstellung des
              Websitebetriebs).
            </p>
          </div>

          <div className="legal-block">
            <p className="legal-label">8. Cookies & Tracking</p>
            <p>Diese Website verwendet keine Cookies, keine Tracking-Tools und keine Analyse-Dienste.</p>
          </div>

          <div className="legal-block">
            <p className="legal-label">9. Datenübermittlung in Drittländer (USA)</p>
            <p>
              Bei Verwendung der Dienste von Netlify (Hosting und Formularübermittlung) kann eine
              Übermittlung personenbezogener Daten in die USA erfolgen. Die Übermittlung erfolgt auf
              Grundlage der EU-Standardvertragsklauseln (SCC) gemäß Art. 46 DSGVO, die ein angemessenes
              Datenschutzniveau gewährleisten.
            </p>
          </div>

          <div className="legal-block">
            <p className="legal-label">10. Sicherheit</p>
            <p>
              Die Website nutzt SSL-Verschlüsselung (https). Es werden angemessene technische und organisatorische
              Maßnahmen ergriffen, um personenbezogene Daten zu schützen.
            </p>
          </div>

          <div className="legal-block">
            <p className="legal-label">11. Ihre Rechte</p>
            <p>Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit und Widerspruch.</p>
            <p>
              Zur Ausübung dieser Rechte wenden Sie sich an <a href="mailto:office@physiotherapie-oliverbauer.com">office@physiotherapie-oliverbauer.com</a>.
            </p>
          </div>

          <div className="legal-block">
            <p className="legal-label">12. Beschwerderecht</p>
            <p>
              Österreichische Datenschutzbehörde<br />
              Barichgasse 40–42<br />
              1030 Wien<br />
              <a href="https://www.dsb.gv.at" target="_blank" rel="noopener noreferrer">www.dsb.gv.at</a>
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
